/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  general: {
    save: 'சேமிக்கவும்',
    autosaved: 'தானாகசேமிக்கப்பட்டது',
    back_to: 'திரும்பு',
    by: 'மூலம்',
    chat: 'சாட்',
    completed: 'நிறைவடைந்தது',
    canceled: 'ரத்து செய்யப்பட்டது',
    component: 'கூறு',
    confirm: 'உறுதிப்படுத்தவும்',
    course: 'படிப்பு',
    date: 'தேதி',
    details: 'விவரங்கள்',
    empty: 'தகவல் இல்லை',
    enrolled: 'பதிவுச் செய்யப்பட்டது',
    free: 'இலவசம்',
    graph: 'வரைபடம்',
    loading: 'ஏற்றுகிறது...',
    lesson: 'பாடம்',
    lessons: 'பாடங்கள்',
    live_assessment: 'நேரலை மதிப்பீடு',
    live_event: 'நேரலை நிகழ்வு',
    no: 'இல்லை',
    of: 'உடைய',
    or: 'அல்லது',
    organization: 'நிறுவனம்',
    page: 'பக்கம்',
    pages: 'பக்கங்கள்',
    personal: 'தனிப்பட்ட',
    poll: 'கருத்து கணிப்பு',
    rating: 'மதிப்பீடு',
    reset: 'மீட்டமை',
    signin: 'உள்நுழைக',
    signup: 'பதிவுபெறுக',
    soon: 'விரைவில்',
    type: 'வகை',
    uploading: 'பதிவேற்றுகிறது...',
    yes: 'ஆம்',
    something_went_wrong: 'ஏதோ தவறு ஏற்பட்டிருக்கிறது!',
    view_all: 'அனைத்தையும் காட்டு',
    upload_successful: 'பதிவேற்றம் வெற்றியடைந்தது',
    upload_successful_message:
      'உங்கள் எக்செல் ஆவணங்கள் வெற்றிகரமாக பதிவேற்றம் செய்யப்பட்டு தற்போது செயலாக்கப்படுகின்றன. இது சிறிது நேரம் எடுக்கலாம்.',
    check_email_upload_successful:
      'பதிவேற்றிய பயனர் பட்டியலின் </1>அறிக்கைக்கு<1> தயவுசெய்து <0>உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்</0>.',
    is_private: 'தனிப்பட்ட'
  },

  account: {
    title: 'கணக்கு',
    subtitle: 'உங்கள் அமைப்புகள் மற்றும் கணக்கு தகவல்களை நிர்வகிக்கவும்.',
    saved: 'கணக்கு வெற்றிகரமாக மாற்றப்பட்டது'
  },

  assessments: {
    title: 'மதிப்பீடுகள்',
    subtitle: 'ஒரு மதிப்பீட்டை உருவாக்கவும்',
    finished: 'மதிப்பீடு முடிந்தது',
    countdown: 'இல் நேரலை மதிப்பீடு ஒளிபரப்பப்படும் ',
    create: 'மதிப்பீட்டை உருவாக்கவும்',
    list_title: 'உங்கள் மதிப்பீடுகள்',
    delete_warning:
      'இந்த உருப்படியை நீக்க விரும்புவதில் நீங்கள் உறுதியாக உள்ளீர்களா?',
    details_title: 'மதிப்பீட்டு விவரங்களைச் சேர்க்கவும்',
    details_subtitle:
      'உங்கள் மதிப்பீட்டிற்கு பெயரிட்டு, மேலும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள எதிர்பார்க்க வேண்டும் என்பதை பார்வையாளர்களிடம் சொல்லுங்கள்.',
    disclaimer: `எனது பதிவு செய்யப்பட்ட மதிப்பீடு பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
    - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
    - அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
    - மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
    - பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
    - எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
    - எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    assessment_details: 'மதிப்பீட்டு விவரங்கள்',

    assessment_settings: 'மதிப்பீட்டு அமைப்புகள்'
  },

  buildersettings: {
    title: 'அமைப்புகளை வெளியிடுக',
    subtitle:
      'உங்கள் நிகழ்வைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் நிகழ்வில் அமைப்புகளைச் சேர்க்கவும்'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'சேர்க்கவும்',
    add_page: 'பக்கத்தைச் சேர்க்கவும்',
    add_lesson: 'பாடங்களைச் சேர்க்கவும்',
    add_answer: 'புதிய பதிலைச் சேர்க்கவும்',
    add_group: 'குழுவைச் சேர்க்கவும்',
    add_organization: 'நிறுவனத்தைச் சேர்க்கவும்',
    add_question: 'கேள்வியைச் சேர்க்கவும்',
    add_quiz: 'வினாடி வினாவைச் சேர்க்கவும்',
    add_users: 'பயனர்களைச் சேர்க்கவும்',
    back: 'திரும்பு',
    back_to_course: 'படிப்பின் கண்ணோட்டத்திற்குத் திரும்பு',
    back_to_lesson: 'பாட கண்ணோட்டத்திற்குத் திரும்பு',
    back_to_media: 'மீடியா நூலகத்திற்குத் திரும்பு',
    back_to_details: 'விவரங்களுக்குத் திரும்பு',
    cancel: 'ரத்துசெய்',
    clear: 'அழி',
    close: 'மூடு',
    clone: 'குளோன்',
    close_lesson: 'பாடத்தை மூடு',
    clone_course: 'குளோன் படிப்பு',
    confirm: 'உறுதிப்படுத்தவும்',
    create: 'உருவாக்கு',
    download: 'பதிவிறக்கவும்',
    download_mass_user_tamplate: 'டெம்ப்ளேட்டைப் பதிவிறக்கவும்',
    add_mass_users: 'பெரிய எண்ணிக்கை பயனர்களைச் சேர்க்கவும்',
    upload_excel_list: 'எக்செல் பட்டியலைப் பதிவேற்றுக',
    delete: 'மீடியாவை நீக்கு',
    edit: 'திருத்து',
    edit_course: ' படிப்பைத் திருத்து',
    enroll: 'பதிவுசெய்க',
    finish: 'முடிக்கவும்',
    upload_image: 'படத்தை பதிவேற்றம் செய்யவும்',
    upload_image_video: 'படம் அல்லது வீடியோவைப் பதிவேற்றவும்',
    select_media_library: 'மீடியா நூலகத்தைத் தேர்ந்தெடுக்கவும்',
    make_public: 'பகிரங்கமாக்குங்கள்',
    make_private: 'தனிப்பட்டதாக்குங்கள்',
    make_org: 'நிறுவனத்தை உருவாக்குங்கள்',
    media: 'மீடியா நூலகம்',
    my_theme: 'எனது தீம்',
    next: 'அடுத்தது',
    next_lesson: 'அடுத்த பாடம்',
    next_step: 'அடுத்தப் படி',
    previous_step: 'முந்தைய படி',
    publish: 'வெளியிடு',
    publish_assessment: 'உங்கள் மதிப்பீட்டை வெளியிடுங்கள்',
    publish_course: 'உங்கள் படிப்பை வெளியிடுங்கள்',
    publish_event: 'உங்கள் நிகழ்வை வெளியிடுங்கள்',
    reset: 'மீட்டமை',
    reset_elements: 'கூறுகளை மீட்டமை',
    save: 'சேமிக்கவும்',
    creating: 'உருவாக்குகிறது...',
    updating: 'அப்டேட் செய்கிறது...',
    saved: 'சேமிக்கப்பட்டது',
    save_for_later: 'பிறகு சேமிக்கவும்',
    save_settings: 'அமைப்புகளைச் சேமிக்கவும்',
    select_files: 'கோப்புகளைத் தேர்ந்தெடுக்கவும்',
    select_theme: 'தீம் தேர்ந்தெடுக்கவும்',
    start_lesson: 'பாடத்தைத் தொடக்கவும்',
    update: 'அப்டேட்',
    upload: 'பதிவேற்றவும்',
    upload_audio: 'ஆடியோவைப் பதிவேற்றுக',
    upload_photo: 'ஒரு சுயவிவரப் புகைப்படத்தைப் பதிவேற்றுக',
    upload_video: 'வீடியோவைப் பதிவேற்றவும்',
    enrolled: 'பதிவுச் செய்யப்பட்டது',
    unenroll: 'பதிவை நீக்கு',
    from_library: 'மீடியா நூலகம்',
    remove: 'நீக்கு',
    removed: 'நீக்கப்பட்டது',
    start_broadcast: 'ஒளிபரப்பைத் தொடங்குங்கள்',
    end_broadcast: 'ஒளிபரப்பை முடிக்கவும்',
    camera: 'கேமரா',
    screen: 'திரை',
    screen_with_camera: 'கேமராவுடன் திரை',
    insert: 'செருகு',

    inserting: 'செருகுகிறது'
  },

  card: {
    quick_add: 'விரைவாக சேர்க்க',
    add: 'சேர்',
    clone: 'குளோன்',
    completed: 'பாடங்கள் முடிந்தது'
  },

  course: {
    upcoming_course: 'வரவிருக்கும் படிப்பு',
    unPublishEvent: 'வெளியிடாத நிகழ்வு',
    unPublishAssessment: 'வெளியிடாத மதிப்பீடு',
    pastCourse: 'பயிற்சி படிப்பு',
    upcoming: 'வரவிருக்கும் நேரலை நிகழ்வு',
    pastEvent: 'கடந்த நேரலை நிகழ்வு',
    pastAssessment: 'கடந்த நேரலை மதிப்பீடு',
    upcomingAssessment: 'வரவிருக்கும் நேரலை மதிப்பீடு',
    created: 'உருவாக்கிய தேதி:',
    assignees: 'ஒதுக்கீட்டாளர்கள்',
    organisations:
      ' {{ நிறுவனங்கள் }} நிறுவனங்கள், <2> {{ பயனர்கள் }} பயனர்கள்</2>',
    event_date: 'நேரலை நிகழ்வு தேதி <1> {{ தேதி }} </1>',
    delete_warning: 'இதை நீக்க விரும்புவதை நீங்கள் உறுதி செய்கிறீர்களா',
    clonning_no_lesson:
      'இந்த கோர்ஸை குளோன் செய்ய குறைந்தபட்சம் ஒரு பாடத்தையாவது தயவுசெய்து சேர்க்கவும்.',
    clone_warning: 'இதை குளோன் செய்ய விரும்புவதை நீங்கள் உறுதி செய்கிறீர்களா',
    clone_success: 'குளோனிங் செயல்பாட்டில் உள்ளது',
    disclaimer: `எனது படிப்புப் பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
- எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`
  },

  coursecreate: {
    dropzone_text: 'மீடியாவைச் செருகவும்',
    sidebar_text:
      'உங்கள் <3 /> பாடங்களுக்கு ஒரு தீம் <1 /> ஐத் தேர்ந்தெடுக்கவும்',
    delete_warning:
      'இந்த பாடத்தை நீக்க விரும்புவதை நீங்கள் உறுதிப்படுத்துகிறீர்களா?'
  },

  coursepage: {
    quizview_loading: 'பதில்களைச் சரிபார்க்கிறது. தயவுசெய்து காத்திருங்கள்...',
    quizview_answer: 'உங்கள் பதில்'
  },

  coursequiz: {
    title: 'அனைத்து பாடங்களிலும் வினாடி வினாக்கள்'
  },

  dashboard: {
    tooltip_title: 'இந்த வீடியோவை மீண்டும் காட்ட வேண்டாம்',
    page_title: 'உங்கள் படிப்புகளின் புள்ளிவிவரம்',
    page_subtitle: 'நீங்கள் உருவாக்கிய படிப்புகளின் நிலை',
    profile_add_info:
      'உங்கள் சுயவிவரத்தை முடிக்க உங்கள் <1>{{முழுமையற்ற உரை}}</1> ஐச் சேர்க்கவும்.',
    profile_build:
      'உங்கள் சுயவிவரத்தை உருவாக்கவும் <1>இங்கே</ 1>, உங்கள் ஆர்வங்களையும் திறன்களையும் எங்களுக்குத் தெரியப்படுத்துங்கள்.',
    profile_title: 'சுயவிவர வலிமை',
    more_details: 'கூடுதல் தகவல்கள்'
  },

  errors: {
    answer: 'தயவுசெய்து பதிலை உள்ளிடுக',
    answer_correct: 'சரியான பதிலைத் தேர்வுசெய்க',
    code: 'தயவுசெய்து உங்கள் குறியீட்டை உள்ளிடவும்',
    criterion: 'தயவுசெய்து அளவுகோலை உள்ளிடவும்',
    duration: 'கால அளவு தேவைப்படுகிறது',
    element: 'தயவுசெய்து கூறை உள்ளிடவும',
    email: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்',
    email_invalid: 'உள்ளிடப்பட்ட மின்னஞ்சல் தவறானது',
    feedback_correct: 'தயவுசெய்து கருத்தை சரியாக உள்ளிடவும்',
    feedback_incorrect: 'உள்ளிடப்பட்ட கருத்து தவறானது',
    host: 'தயவுசெய்து நிகழ்வு ஹோஸ்டை உள்ளிடவும்',
    host_assessment: 'தயவுசெய்து மதிப்பீட்டு ஹோஸ்டை உள்ளிடவும்',
    image: 'தயவுசெய்து ஒரு படத்தை பதிவேற்றவும்',
    location: 'தயவுசெய்து உங்கள் இருப்பிடத்தை உள்ளிடவும்',
    live_location: 'தயவுசெய்து ஒரு ஒளிபரப்பு இருப்பிடத்தைத் தேர்வுசெய்க',
    limit: 'தயவுசெய்து லைவ்-ஸ்ட்ரீமிங் நிமிடங்களை உள்ளிடவும்',
    min_3char: 'குறைந்தபட்சம் 3 எழுத்துக்கள்',
    number: 'தயவுசெய்து நேர்மறை எண்ணை உள்ளிடவும்.',
    host_email_require: `ஹோஸ்டின் மின்னஞ்சல்கள் தேவைப்படுகிறது.`,
    attendee_email_require: `பங்கேற்பாளரின் மின்னஞ்சல்கள் தேவைப்படுகிறது.`,
    name: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்',
    not_found_course: ' படிப்புக் கிடைக்கவில்லை',
    not_found_event: 'நிகழ்வு கிடைக்கவில்லை',
    not_found_assessment: 'மதிப்பீடு கிடைக்கவில்லை',
    password: 'தயவுசெய்து உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
    password_digit: 'குறைந்தபட்சமாக ஒரு எண் தேவை',
    password_short:
      'கடவுச்சொல் மிகச் சிறியதாக உள்ளது, குறைந்தபட்சம் 10 எழுத்துக்கள் தேவை',
    password_special: 'குறைந்தபட்சம் ஒரு ஸ்பெஷல் எழுத்து தேவை',
    password_uppercase: 'குறைந்தது ஒரு பெரிய எழுத்து தேவை',
    password_lowercase: 'குறைந்தது ஒரு சிறிய எழுத்து தேவை',
    phone: 'தயவுசெய்து உங்கள் தொலைபேசியை உள்ளிடவும்',
    phone_invalid: 'தவறான தொலைபேசி எண்',
    position: 'தயவுசெய்து உங்கள் நிலையை உள்ளிடவும்',
    question: 'தயவுசெய்து கேள்வியை உள்ளிடவும்',
    start_date: 'தொடங்கும் தேதி & நேரம் தேவைப்படுகிறது',
    tag: 'தயவுசெய்து ஒரு குறிச்சொல்லைத் தேர்ந்தெடுக்கவும்',
    topics: 'தயவுசெய்து ஒரு தலைப்பையாவது தேர்ந்தெடுக்கவும்.',
    live_topics: 'தயவுசெய்து தலைப்புகளைச் சேர்க்கவும்',
    title: 'தயவுசெய்து தலைப்பை உள்ளிடுக',
    title_assessment: 'தயவுசெய்து மதிப்பீட்டு தலைப்பை உள்ளிடவும்',
    title_course: 'தயவுசெய்து படிப்புத் தலைப்பை உள்ளிடவும்',
    title_empty: 'தலைப்பு காலியாக இருக்கக்கூடாது',
    title_event: 'தயவுசெய்து நிகழ்வு தலைப்பை உள்ளிடவும்',
    title_lesson: 'தயவுசெய்து பாடத்தலைப்பை உள்ளிடவும்',
    title_quiz: 'தயவுசெய்து வினாடி வினா பெயரை உள்ளிடவும்',
    username: 'தயவுசெய்து உங்கள் பயனர்பெயரை உள்ளிடவும்',
    upload_error: 'பிழை - கோப்பு பொருந்தவில்லை!',
    upload_more_than_10:
      'நீங்கள் ஒரே நேரத்தில் அதிகபட்சம் 10 கோப்புகளை மட்டுமே பதிவேற்ற முடியும்.',
    topics_max: 'தயவுசெய்து அதிகபட்சம் 3 தலைப்புகளைச் சேர்க்கவும்.',
    upload_excel:
      'தயவுசெய்து நீங்கள் சரியான கோப்பை பதிவேற்றியுள்ளீர்கள் என்பதை உறுதிப்படுத்தவும்.',
    title_excel: 'டெம்ப்ளேட்டை பதிவேற்றுவதில் பிழை:',
    file_size_exceed: 'கோப்பு அளவு மீறியது',
    subtitle_excel:
      'தயவுசெய்து நீங்கள் வழங்கப்பட்ட டெம்ப்ளேட்டை பயன்படுத்துகிறீர்கள் மற்றும் நெடுவரிசைகள் சரியாக நிரப்பப்படுகின்றன என்பதை உறுதிப்படுத்தவும்.',
    select_broadcast_option:
      'தயவுசெய்து இந்த நிகழ்வை ஒளிபரப்ப ஒரு விருப்பத்தேர்வை தேர்ந்தெடுக்கவும்',
    multi_hosts_number_error:
      'தொகுப்பாளரின் எண்ணிக்கை நிகழ்வுக்காக குறிப்பிடப்பட்டதை விட அதிகமாக இருக்கக்கூடாது.',
    conference_people_number_error: `பங்கேற்பாளரின் எண்ணிக்கை நிகழ்வுக்காக குறிப்பிடப்பட்டதை விட அதிகமாக இருக்கக்கூடாது.`,
    select_max_host:
      'நிகழ்வுக்காக குறைந்தது 1 தொகுப்பாளரைத் தேர்ந்தெடுக்கவும்.',
    select_max_conference:
      'நிகழ்வுக்காக குறைந்தது 1 பங்கேற்பாளரைத் தேர்ந்தெடுக்கவும்.',
    stream_stop_error: 'எதிர்பாராத விதமாக ஸ்ட்ரீமிங் நிறுத்தப்பட்டது!',
    unsecure_context:
      'அபாயகரமான பிழை: பாதுகாப்பற்ற சூழல் காரணமாக கேமரா மற்றும் மைக்கை ப்ரௌசரால் அணுக முடியாது. தயவுசெய்து SSL ஐ நிறுவி https வழியாக அணுகவும்',
    ws_not_supported:
      'அபாயகரமான பிழை: இந்த ப்ரௌசரில் வெப்சாக்கெட் ஆதரிக்கப்படவில்லை',
    no_org: 'தொடர குறைந்தது 1 அமைப்பைத் தேர்ந்தெடுக்கவும்.',
    no_org_group: 'தொடர குறைந்தபட்சம் 1 நிறுவன குழுவையாவது தேர்ந்தெடுக்கவும்.',
    waiting_to_join: 'யாராவது சேரக் காத்திருக்கிறார்கள்!'
  },

  events: {
    title: 'நேரலை நிகழ்வு விவரங்களைச் சேர்க்கவும்',
    change_host: 'ஹோஸ்டை மாற்றவும்',
    finished: 'நிகழ்வு முடிந்தது',
    countdown: 'இல் நேரலை நிகழ்வு ஒளிபரப்பப்படும் ',
    subtitle:
      'உங்கள் நேரலை நிகழ்வுக்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள  எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்.',
    poll_disabled: 'இந்த நிகழ்வில் கருத்து கணிப்பு கிடைக்கவில்லை',
    disclaimer: `எனது பதிவு செய்யப்பட்ட நிகழ்வு பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
  - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    prompt_message:
      'இந்தப் பக்கத்தை விட்டு வெளியேறுவது உங்கள் நிகழ்வை முடிக்கும். இந்தப் பக்கத்தை விட்டு வெளியேறுவதில் நீங்கள் உறுதியாக இருக்கிறீர்களா?',
    duration_exceed_message:
      'உங்கள் ஒளிபரப்பு நேரம் மீறியது, ஆப் ஒளிபரப்பை நிறுத்தப் போகிறது.',
    before_schedule_message:
      'திட்டமிடப்பட்ட நிகழ்வு நேரத்திற்கு முன்பே நீங்கள் ஒளிபரப்பைத் தொடங்க உள்ளீர்கள். ஒளிபரப்பை நிறுத்தினால் நிகழ்வு முடிவடையும் என்பதை நினைவில் கொள்ளுங்கள்.',
    browser_unsupportive_message:
      'உங்கள் உலாவி திரை பகிர்வை ஆதரிக்கவில்லை. இந்த இணைப்பில் ஆதரிக்கப்பட்ட உலாவிகளைக் காணலாம்',
    cancel_switch_host_message:
      'ஹோஸ்ட் கிடைக்கவில்லை. நிகழ்வு உங்கள் தரப்பிலிருந்து தொடரும்.',
    coaching_prompt_message:
      'நிகழ்வு முடியும் வரை இந்த பக்கத்தை விட்டு நீங்கள் வெளியேற முடியாது.',
    event_modal_warn: ' நீங்கள் இந்த நிகழ்வை விட்டு வெளியேற விரும்புகிறீர்களா?',
    confirm_message:
      'நீங்கள் OK என்பதைக் கிளிக் செய்தால் உங்கள் நிகழ்வு முடிவடையும்.',
    screen_share_denied: 'உங்கள் திரையைப் பகிர நீங்கள் மறுத்துவிட்டீர்கள்',
    media_not_found:
      'உங்கள் சாதனத்தில் கேமரா அல்லது மைக் காணப்படவில்லை அல்லது அனுமதிக்கப்படவில்லை.',
    media_not_access:
      'கேமரா அல்லது மைக் சாதனங்கள் வேறு சில செயல்களால் பயன்படுத்தப்படுகிறது அதனால் அதை ரீட் செய்ய முடியவில்லை',
    constraint_error:
      'உங்கள் வீடியோ மற்றும் ஆடியோ கட்டுப்பாடுகளுக்கு பொருந்தக்கூடிய எந்த சாதனமும் இல்லை. நீங்கள் வீடியோ மற்றும் ஆடியோ கட்டுப்பாடுகளை மாற்றலாம்',
    media_access_denied: 'கேமரா மற்றும் மைக்கை அணுக உங்களுக்கு அனுமதி இல்லை.'
  },

  filters: {
    days7: 'கடந்த 7 நாட்கள்',
    days15: 'கடந்த 15 நாட்கள்',
    days30: 'கடந்த 30 நாட்கள்',
    days365: 'கடந்த 365 நாட்கள்',
    date: 'உருவாக்கப்பட்ட தேதி',
    relevance: 'தொடர்பான',
    popularity: 'பிரபலமான',
    name: 'பெயர்',
    group: 'குழு',
    Newest_to_Oldest: 'புதியது முதல் பழையது',
    Oldest_to_Newest: 'பழையது முதல் புதியது',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'உங்கள் கணக்கின் பாதுகாப்பை உறுதிப்படுத்த, உங்கள் கடவுச்சொல்லில் குறைந்தபட்சம் ஒரு சிறிய எழுத்து, எண் தேவை. நீங்கள் குறைந்தபட்சம் 10 எழுத்துகளின் நீளத்தையும் கொண்டிருக்க வேண்டும்.',
    phone:
      'உங்கள் நாட்டின் தொலைபேசி குறியீட்டைச் சேர்க்கவும், எடுத்துக்காட்டாக: +65',
    username:
      'உங்கள் பயனர்பெயர் பொதுத் தகவலாகக் கருதப்படுகிறது மற்றும் தேவைக்கேற்ப பிற பயனர்களுடன் பகிரப்படுகிறது. எனவே, உங்கள் பயனர்பெயரில் தனிப்பட்ட தகவல்களைப் பயன்படுத்த வேண்டாம் என்று நாங்கள் பரிந்துரைக்கிறோம்',
    public_description_normal:
      'உங்கள் <0><0/></0> சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள், நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். ஷேர்லுக் கணக்குடன் தொடர்புடைய அவர்களின் மின்னஞ்சல் முகவரியைப் பயன்படுத்தி குறிப்பிட்ட பயனர்களுடன் உங்கள் பாடத்திட்டத்தைப் பகிர குறிப்பிட்ட பயனர்களின் விருப்பத்தேர்வு உதவுகிறது.',
    public_description_admin:
      'இது <0><0/></0> சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் (மற்றும் உள்ளடக்கம் உருவாக்கியவர்) மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது உங்கள் நிறுவனத்திற்கு வெளியே உள்ளவர்கள் உட்பட மேடையில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். அதை நிறுவனத்திற்கு வெளியிடுவது என்பது நிறுவனத்திற்குள் உள்ள அனைத்து பயனர்களும் அதைப் பார்க்க முடியும் என்பதாகும். நீங்கள் இதை 1 அல்லது அதற்கு மேற்பட்ட குழுக்களுக்கும் வெளியிடலாம், அதாவது அந்தக் குழுக்களில் உள்ள பயனர்கள் மட்டுமே அதைப் பார்க்க முடியும். கடைசியாக, உங்கள் நிறுவனத்திற்கு உள்ளேயும் வெளியேயும் குறிப்பிட்ட பயனர்களுக்கு அவர்களின் ஷேர்லுக் கணக்கு மின்னஞ்சல் முகவரியைப் பயன்படுத்தி வெளியிட உங்களுக்கு விருப்பத்தேர்வு உள்ளது.'
  },

  labels: {
    add: 'சேர்க்கவும்',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'பதில் வகை',
    answers: 'பதில்கள்',
    back_to_quiz: 'வினாடி வினா பட்டியலுக்குத் திரும்பு',
    back_to_question: 'கேள்விகள் பட்டியலுக்குத் திரும்பு',
    chat: 'சாட்',
    chat_available: 'இந்த நிகழ்வில் சாட் கிடைக்கவில்லை',
    chat_report: 'சாட் அறிக்கை',
    choice_single: 'ஒற்றை தேர்வு',
    choice_multiple: 'பலவகை தேர்வு',
    choice_free: '"இலவச" தேர்வு',
    choice_sorting: '"வரிசை" தேர்வு',
    choice_matrix: '"மேட்ரிக்ஸ் வரிசை" தேர்வு',
    clone_lesson_permission: 'குளோன் அனுமதி',
    code: 'குறியீடு',
    correct: 'சரியான',
    created: 'உருவாக்கப்பட்ட தேதி',
    clone_modal: 'குளோன் படிப்பு',
    cloning_course: ' படிப்பை குளோனிங் செய்கிறது...',
    cloning: 'குளோனிங்...',
    cloning_course_desc:
      'இந்த செயல்முறை சிறிது நேரம் எடுக்கும். தயவுசெய்து பொறுமையாக இருங்கள்',
    cloning_success: '"<0/>" படிப்பு வெற்றிகரமாக குளோன் செய்யப்பட்டுள்ளது!',
    description: 'விளக்கம்',
    disclaimer: 'உரிமைத் துறப்பு',
    drop_file: 'கோப்பை இங்கே விடுங்கள்...',
    duration: 'கால அளவு',
    edit: 'திருத்து',
    email: 'மின்னஞ்சல்',
    event: 'நிகழ்வு',
    event_all: 'அவரது அனைத்து நிகழ்வுகளும்',
    event_date: 'நேரலை நிகழ்வின் உள்ளூர் தேதி/நேரம்',
    event_this: 'இந்த நிகழ்வு',
    expire: 'காலாவதியாகிறது',
    expiry_date: 'காலாவதி தேதி',
    forgot: 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
    group: 'குழு',
    groups_list: 'குழுக்களின் பட்டியல்',
    host: 'ஹோஸ்ட்',
    id_annotation: ' விரிவுரை ஐடி',
    id_quiz: 'வினாடி வினா ஐடி',
    incorrect: 'தவறானது',
    interests: 'ஆர்வங்கள்',
    invited: 'அழைக்கப்பட்டார்',
    live_chat: 'நேரலை கலந்துரையாடல்',
    live_stream_limit: 'நேரலை-ஸ்ட்ரீமிங் நிமிடங்கள்',
    contact_text:
      'உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற தயவுசெய்து தொடர்பு கொள்ளவும்',
    contact_admin:
      '<0>உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற விரும்பினால் தயவுசெய்து தொடர்பு கொள்ளவும்</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'மீதமுள்ள நேரலை ஸ்ட்ரீமிங் நிமிடங்கள்: <0>{{ limit }}</0> minutes <1/><2/> <3>உங்கள் மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பை மாற்ற தயவுசெய்து தொடர்பு கொள்ளவும்</3> <4>admin@sharelook.com</4>',
    location: 'இடம்',
    lessons: 'பாடங்கள்',
    location_broadcast: 'ஹோஸ்ட் சேவையக இருப்பிடம்',
    location_broadcast_subtitle:
      'ஆடியோவிஷுவல் தாமதத்தைக் குறைக்க ஒளிபரப்பு ஹோஸ்டின் இருப்பிடத்திற்கு மிக நெருக்கமான ஒரு இருப்பிடத்தைச் சேர்க்கவும்',
    media_manager: 'மீடியா மேலாளர்',
    minutes: 'நிமிடங்கள்',
    name: 'பெயர்',
    online_quiz: 'ஆன்லைன் வினாடி வினா',
    organiser: 'நூலாசிரியர்',
    organization: 'நிறுவனம்',
    overall_emotion: 'ஒட்டுமொத்த அனுபவம்:',
    organizations_list: 'நிறுவனங்களின் பட்டியல்',
    password: 'கடவுச்சொல்',
    participants: 'பங்கேற்பாளர்கள்',
    picture: 'படம் (16:9)',
    phone: 'தொலைபேசி',
    photo: 'புகைப்படம்',
    poll: 'கருத்து கணிப்பு',
    position: 'நிலை',
    processing: 'செயலாக்கம்',
    privacy_settings: 'தனியுரிமை அமைப்புகள்',
    question: 'கேள்வி',
    quiz_create: 'புதிய வினாடி வினாவை உருவாக்கவும்',
    quiz_name: 'வினாடி வினாவின் பெயர்',
    quiz_update: 'வினாடி வினாவைப் புதுப்பிக்கவும்',
    select_organization: 'ஒரு நிறுவனத்தைத் தேர்ந்தெடுக்கவும்',
    settings: 'அமைப்புகள்',
    show: 'காட்டு',
    show_graph: 'வரைபட முடிவைக் காட்டு',
    signin: 'உள்நுழைக',
    signup: 'பதிவுபெறுக',
    sort_by: 'மூலம் வரிசைப்படுத்து',
    start_date: 'தொடக்க தேதி',
    tags: 'குறிச்சொற்கள்',
    terms:
      'இந்த <1>விதிமுறைகளையும் நிபந்தனைகளையும்</1> நான் ஒப்புக்கொள்கிறேன்.',
    title: 'தலைப்பு',
    topics: 'தலைப்புகள்',
    topic: 'தலைப்பு',
    total_comments: 'மொத்த கருத்துகள்',
    username: 'பயனர்பெயர்',
    users_list: 'பயனர்களின் பட்டியல்',
    users_emails: 'குறிப்பிட்ட பயனர்களின் மின்னஞ்சல்களைச் செருகவும்',
    description_specifiction_email:
      'பல குறிப்பிட்ட பயனர்களுடன் இதைப் பகிர ஒரு வரியில் 1 மின்னஞ்சல் முகவரியை தயவுசெய்து உள்ளிடவும்.',
    message_specific_email:
      'தயவுசெய்து குறிப்பிட்ட பயனரின் ஒரு மின்னஞ்சலை உள்ளிடவும்.',
    viewers: 'பார்வையாளர்கள்',
    edit_course: 'திருத்து',
    edit_assessment: 'திருத்து',
    edit_event: 'திருத்து',
    delete_course: 'நீக்கு',
    delete_event: 'நீக்கு',
    delete_assessment: 'நீக்கு',
    view_course: 'காண்க',
    view_event: 'காண்க',
    view_assessment: 'காண்க',
    date_event: 'நேரலை நிகழ்வின் தேதி',
    date_assessment: 'நேரலை மதிப்பீட்டின் தேதி',
    clone_of: 'குளோன்',
    clone_course:
      'எல்லா பாடங்களும் மற்றும் பக்கங்களும் அடங்கிய, நீங்கள் அசலில் இருந்து சுயாதீனமாக மாற்றக்கூடிய, இந்த பாடத்தின் ஒரு குளோனை உருவாக்கவும்.',
    make: 'செய்யுங்கள்',
    available_to: 'எந்தவொரு ஷேர்லூக் பயனருக்கும் கிடைக்கும்',
    uploaded_by: 'மூலம் பதிவேற்றியது: ',
    course: 'படிப்பு',
    assessment: 'மதிப்பீடு',
    user_not_exist:
      'பயனர் இல்லை, நீங்கள் ஒரு அழைப்பை அனுப்ப விரும்புகிறீர்களா?',
    check_user: 'அறிவிப்பு',
    user_not_exist_in_org:
      'இந்த நிறுவனத்தில் பயனர் இல்லை, நீங்கள் ஒரு அழைப்பை அனுப்ப விரும்புகிறீர்களா?',
    title_modal_stream: 'நிறுவன நேரலை ஸ்ட்ரீம் வரம்பை மாற்றவும்',
    des_warning_stream: 'நீங்கள் மாற்றப் போகிறீர்கள்',
    monthly_stream: 'மாதாந்திர நேரலை-ஸ்ட்ரீமிங் வரம்பு:',
    min_per_month: 'நிமிடங்கள்/மாதம்',
    broadcast_label: 'நான் செய்ய விரும்புகிறேன்:',
    hosts_emails: `குறிப்பிட்ட ஹோஸ்டின் மின்னஞ்சல்களைச் செருகவும்`,
    attendee_emails: `குறிப்பிட்ட பங்கேற்பாளரின் மின்னஞ்சல்களைச் செருகவும்`,
    description_host_specifiction_email:
      'தயவுசெய்து ஒரு வரிக்கு 1 மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
    presenter_label: 'தொகுப்பாளர்',
    presenter_label_conference: 'மக்களின் எண்ணிக்கை',
    event_privacy: 'கலந்தாய்வு முறை',

    alert: 'எச்சரிக்கை!',
    warning: 'எச்சரிக்கை',
    ok: 'சரி',
    cancel: 'ரத்துசெய்',
    done: 'முடிந்தது',
    insert: 'செருக',
    private: 'தனிப்பட்ட',
    public: 'பொது',
    no_connection: 'Internet Connection Lost',
    switch: 'சொடுக்கி',
    share_screen: 'பகிர் திரை',
    stop_share_screen: '',
    share_screen_with_camera: 'பகிர் திரையை நிறுத்து',
    stop_share_screen_with_camera: 'கேமராவுடன் பகிர் திரையை நிறுத்துங்கள்',
    camera_on: 'கேமரா இயக்கப்பட்டது',
    camera_off: 'கேமரா முடக்கப்பட்டுள்ளது',
    mic_on: 'ஊமையாக இல்லை',
    mic_off: 'ஊமையாக',
    fullscreen: 'முழு திரை',
    live_now: 'இப்போது வாழ்க',
    schedule_on: 'க்கான அட்டவணை',
    organisations: 'நிறுவனங்கள்',
    org_groups: 'அமைப்பு குழுக்கள்',
    specific_user: 'Specific User',
    gif: 'GIF',
    unavailable: 'கிடைக்கவில்லை',
    yes: 'ஆம்',
    no: 'இல்லை',
    event_duration_message: 'அதிகபட்சம் 300 நிமிடங்கள் (5 மணி)',
    send_email: 'மின்னஞ்சல் அறிவிப்பை அனுப்பவும்',
    admin_only: 'நிர்வாகி மட்டும்',
    join: 'சேர',
    leave: 'விடுங்கள்'
  },

  broadcastOptions: {
    stream_from_phone: 'எனது தொலைபேசியுடன் நேரலை ஒளிபரப்பு',
    other_webrtc: 'எனது கணினியிலிருந்து வெபினார்',
    multihost: 'எனது கணினியிலிருந்து மல்டிகாஸ்ட் வெபினார்',
    peer2peer: 'பயிற்சி அமர்வு',
    conference: 'நேரலை கலந்தாய்வு'
  },

  lessoncreate: {
    title: 'பாட விவரங்களைச் சேர்க்கவும்',
    subtitle:
      'உங்கள் பாடத்திற்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்.',
    input_label_title: 'பாடத் தலைப்பு',
    input_label_topics: 'பாடத் தலைப்புகள்',
    input_label_description: 'பாட விளக்கம்',
    delete_warning:
      'இந்தப் பக்கத்தை நீக்க விரும்புவதை நீங்கள் உறுதிப்படுத்துகிறீர்களா?'
  },

  lessonoverview: {
    title: 'பாடத்தைச் சேர்க்கவும்',
    subtitle:
      'ஏற்கனவே உள்ள பாடத்தைச் சேர்க்கவும் அல்லது புதிய ஒன்றை உருவாக்கவும்',
    new_lesson: 'ஒரு புதிய பாடத்தை உருவாக்கவும்',
    new_lesson_sub: 'புதிதாக ஒரு புதிய பாடத்தை உருவாக்கவும்!',
    existing_lesson: 'ஏற்கனவே இருக்கும் பாடத்தைத் தேர்ந்தெடுக்கவும்',
    existing_lesson_sub:
      'ஏற்கனவே உள்ள ஒரு பாடத்திற்கான இணைப்பு, இந்த பாடத்தில் செய்யப்பட்ட மாற்றங்கள் மற்ற படிப்பில் உள்ள பாடத்திலும் பாதிக்கும்.',
    clone_lesson: 'ஏற்கனவே உள்ள பாடத்தை நகலெடு',
    clone_lesson_sub:
      'இந்த படிப்பில் உள்ள பாடத்தின் ஒரு தனித்துவமான நகலை உருவாக்கவும், இந்த பாடத்தில் செய்யப்பட்ட மாற்றங்கள் அசல் பாடத்தை பாதிக்காது.',
    clone_lesson_modal_sub:
      'உங்கள் படிப்பில் நீங்கள் சேர்க்க விரும்பும் பாடத்தின் கீழே உள்ள குளோன் பொத்தானை தயவுசெய்து கிளிக் செய்க.'
  },

  management: {
    groups_title: 'குழுக்களை நிர்வகிக்கவும்',
    delete_warning: 'நீங்கள் உறுதியாக இருக்கிறீர்களா?',
    organizations_title: 'எனது நிறுவனங்கள்',
    organizations_subtitle: 'உங்கள் பட்டியலில் நிறுவனங்களைச் சேர்க்கவும்',
    users_title: 'பயனர்களை நிர்வகிக்கவும்',
    users_position: 'மூத்த கணக்கு மேலாளர்',
    user_not_found: 'பயனர் கிடைக்கவில்லை',
    select_org:
      'தயவுசெய்து பயனர்களை நிர்வகிக்க ஒரு நிறுவனத்தைக் கண்டுபிடித்து தேர்வு செய்யவும்'
  },

  audio: {
    modal_title: 'ஆடியோவைச் செருகவும்',
    list_view: 'பட்டியலாக காண்க',
    create_audio_modal_title: 'ஆடியோவை உருவாக்கவும்',
    edit_audio_modal_title: 'ஆடியோவைத் திருத்து',
    public_audio_not_found: 'ஆடியோ கிடைக்கவில்லை.',
    private_audio_not_found:
      'நீங்கள் இதுவரை எந்தவொரு ஆடியோவையும் பதிவேற்றவில்லை',
    are_you_sure_to_delete: 'நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா?',
    type_something: 'ஏதாவது தட்டச்சு செய்யவும்',
    select_voice: 'தேர்ந்தெடு',
    file_name: 'கோப்பு பெயர்',
    description: 'விளக்கம்',
    topic: 'தலைப்பு',
    key_words_tag: 'முக்கிய வார்த்தைகளின் குறிச்சொல்',
    mp3_audio: 'MP3 ஆடியோ',
    created: 'உருவாக்கப்பட்டது',
    duration: 'கால அளவு',
    close: 'மூடவும்'
  },

  image: {
    modal_title: 'படத்தைச் செருகவும்',
    image: 'படம்',
    pixel: 'பிக்சல்',
    dimension: 'பரிமாணம்',
    public_image_not_found: 'படம் கிடைக்கவில்லை.',
    private_image_not_found: 'நீங்கள் இதுவரை எந்தவொரு படத்தையும் பதிவேற்றவில்லை'
  },

  annotation: {
    modal_title: 'விரிவுரை'
  },

  text: {
    modal_title: 'உரை ஆசிரியர்'
  },

  video: {
    modal_title: 'வீடியோவைச் செருகவும்',
    image: 'வீடியோ',
    mp4_video: 'MP4 வீடியோ',
    public_video_not_found: 'வீடியோ கிடைக்கவில்லை.',
    private_video_not_found:
      'நீங்கள் இதுவரை எந்தவொரு வீடியோவையும் பதிவேற்றவில்லை'
  },

  media: {
    title: 'மீடியா நூலகம்',
    subtitle: 'உங்கள் கோப்புகளின் நூலகம்',
    modal_title: 'மீடியாவைப் பதிவேற்றவும்',
    delete_warning: 'நீக்குதலை உறுதிப்படுத்தவும்',
    delete_message:
      'நீக்கப்பட்ட மீடியா அவை பயன்படுத்தப்பட்ட பக்கங்களில் இன்னும் தோன்றும்',
    dropzone_text: 'அல்லது இங்கே இழுத்து விடுங்கள்',
    delete_success: 'மீடியா வெற்றிகரமாக நீக்கப்பட்டது',
    upload_file: 'கோப்பை பதிவேற்றவும்',
    drag_drop: 'அல்லது இங்கே இழுத்து விடுங்கள்',
    import_file: 'உங்கள் கணினியிலிருந்து கோப்பு(களை) இறக்குக',
    no_media: 'நீங்கள் இதுவரை எந்தவொரு மீடியாவையும் பதிவேற்றவில்லை',
    media_type: 'மீடியா வகை',
    video: 'வீடியோ',
    image: 'படம்',
    audio: 'ஆடியோ',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'மீடியா கிடைக்கவில்லை.',
    of: 'உடைய',
    disclaimer: `எனது மீடியா பின்வருவனவற்றை கொண்டிருக்காது என்று நான் உத்தரவாதம் அளிக்கிறேன்:
  - எந்தவொரு மூன்றாம் தரப்பினரின் உரிமைகளையும் மீறுதலை
- அவதூறு, வெறுப்பூட்டுகிற, அநாகரீகமான, மோசமான, ஆபாசமான, வன்முறை, துஷ்பிரயோகம், அவமதிப்பு, அச்சுறுத்தல் அல்லது பாரபட்சமான உள்ளடக்கம், நட்சத்திரக் குறிப்புகளுடன் கூட மறைக்கப்பட்ட உள்ளிட்ட எந்தவொரு சட்டவிரோதத்தையும் கொண்டிருத்தல்
- மற்ற நபர்கள் மீதான தனிப்பட்ட தாக்குதல்களைக் கொண்டிருத்தல்
- பிற பங்கேற்பாளர்கள், பொது நபர்கள் அல்லது பிரபலங்களைப் போல் ஆள்மாறாட்டம் ஆகியவற்றைக் கொண்டிருத்தல்
- எந்தவொரு தனிநபரின் எந்தவொரு பதிவு அல்லது தனிப்பட்ட தகவல்களையும் அத்தகைய நபரின் அனுமதியின்றி கொண்டிருப்பது மற்றும் உலகின் எந்தவொருப் பகுதியின் தகவல் பாதுகாப்பு ஒழுங்குமுறைகளை மீறுதலை
- எந்தவொரு வணிகம் தொடர்பான வற்புறுத்தும் வேண்டுதலை அல்லது எந்த வகையான "ஸ்பேம்" கொண்டிருத்தல்`,
    my_media: 'எனது மீடியா',
    public_library: 'பொது நூலகம்',
    organization_library: 'நிறுவன நூலகம்',
    upload_from_computer: 'கணினியிலிருந்து பதிவேற்றவும்',
    create: 'உருவாக்கு',
    all: 'அனைத்தும்',
    male: 'ஆண்',
    female: 'பெண்',
    processing_audio: 'ஆடியோவை செயலாக்குகிறது',
    create_annotation: 'சிறுகுறிப்பை உருவாக்கவும்',
    popup_over_lesson_text:
      'கிளிக் செய்தபின் பாடத்தின் மேலே சிறுகுறிப்பு பாப் அப் செய்யும்',
    edit_detail: 'விவரங்களைத் திருத்து',
    delete: 'நீக்கு',
    go_create_audio: 'ஆடியோவை உருவாக்கச் செல்லுங்கள்',
    show_more_details: 'மேலும் விவரங்களைக் காட்டு',
    show_less_details: 'குறைந்த விவரங்களைக் காட்டு',
    drop_files: 'பதிவேற்ற வேண்டிய இடத்துக்கு கோப்புகளை விடுங்கள்',
    or: 'அல்லது',
    import_files: 'கணினியிலிருந்து கோப்புகளை இறக்குக'
  },

  navigation: {
    account: 'கணக்கு',
    assessments: 'மதிப்பீடுகள்',
    dashboard: 'டாஷ்போர்டு',
    groups: 'குழு மேலாண்மை',
    logout: 'வெளியேறு',
    organisations: 'நிறுவனங்கள்',
    organizations_users: 'நிறுவனங்கள் மற்றும் பயனர்கள்',
    reports: 'அறிக்கைகள்',
    schedule: 'அட்டவணை',
    training: 'பயிற்சி',
    nowLive: 'ஒளிபரப்பு',
    users: 'பயனர்கள்',
    workshop: 'எனது ஒர்க் ஷாப்'
  },

  onboarding: {
    step1_title: 'படி 1: உங்களைப் பற்றி எங்களுக்கு கொஞ்சம் சொல்லுங்கள்',
    step1_subtitle:
      'உங்கள் பெயர் என்ன? நீங்கள் எங்கிருந்து வருகிறீர்கள்? நீங்கள் என்ன வேலை செய்கிறீர்கள்?',
    step2_title:
      'படி 2: நீங்கள் மேம்படுத்த விரும்பும் சில திறன்களைத் தேர்ந்தெடுக்கவும்',
    step2_subtitle:
      'அடுத்து, நீங்கள் நன்றாக புரிந்து கொள்ள விரும்புவதை எங்களிடம் கூறுங்கள். ஒருவேளை நீங்கள் இன்னும் எதையாவது வளர்த்து கொள்ள விரும்புகிறீர்களா? ஒரு புதிய படிப்பு? உங்கள் அன்புக்குரியவர் என்ன செய்கிறார்?'
  },

  pagebuilder: {
    title: 'பாடத்தை உருவாக்கவும்',
    subtitle:
      'உங்களிடமிருந்து உங்கள் பார்வையாளர்கள் கற்றுக்கொள்ள உள்ளடக்கத்தை உருவாக்கும் நேரம், நீங்கள் படங்கள், வீடியோக்கள் மற்றும் இன்போகிராபிக்ஸ் செய்யலாம்',
    select_layout: 'ஒரு பக்க அமைப்பைத் தேர்ந்தெடுக்கவும்',
    template1: 'காலியான',
    template2: 'தலைப்பு & வசன வரிகள்',
    template3: 'தலைப்பு & உரை',
    template4: 'தலைப்பு, மீடியா மற்றும் உரை',
    template5: 'தலைப்பு & மீடியா',
    template6: 'தலைப்பு & வினாடி வினா'
  },

  pageconstructor: {
    title: 'பாடம் மற்றும் குளோன் செய்யவும்',
    subtitle:
      'உங்களிடமிருந்து உங்கள் பார்வையாளர்கள் கற்றுக்கொள்ள உள்ளடக்கத்தை உருவாக்கும் நேரம், நீங்கள் படங்கள், வீடியோக்கள் மற்றும் இன்போகிராபிக்ஸ் ஆகியவற்றைச் சேர்க்கலாம்'
  },

  passwordreset: {
    success_coded:
      'நீங்கள் வழங்கிய முகவரிக்கு ஒரு உறுதிப்படுத்தல் குறியீட்டை நாங்கள் மின்னஞ்சல் செய்துள்ளோம், தயவுசெய்து புதிய கடவுச்சொல்லை அமைக்க கீழே உள்ள புலத்தில் குறியீட்டை நகலெடுக்கவும்.',
    success_changed:
      'ஒரு புதிய கடவுச்சொல்லை வெற்றிகரமாக அமைத்துள்ளீர்கள். நீங்கள் இப்போது உள்நுழையலாம்.'
  },

  placeholders: {
    search: 'தேடுங்கள்',
    answer: 'பதில்',
    chat: 'ஏதாவது கூறுங்கள்...',
    code: 'குறியீடு',
    criterion: 'அளவுகோல்',
    date_event: 'தேதி & நேரத்தைத் தேர்ந்தெடுக்கவும்',
    date_start: 'தொடக்க தேதி',
    date_expire: 'காலாவதி தேதி',
    description: 'விளக்கம்',
    elements: 'கூறுகளை வரிசைப்படுத்து',
    email: 'மின்னஞ்சல்',
    feedback_correct: 'கருத்து சரியானது',
    feedback_incorrect: 'கருத்து தவறானது',
    host: 'ஹோஸ்ட்',
    keywords: 'முக்கிய வார்த்தை(களை) தேடுங்கள்',
    lesson_description: 'பாட விளக்கம்',
    location: 'இடம்',
    minutes: 'நிமிடங்கள்',
    name: 'பெயர்',
    organiser: 'நூலாசிரியர்',
    organization: 'நிறுவனம்',
    password: 'கடவுச்சொல்',
    phone: 'தொலைபேசி',
    photo: 'புகைப்படம்',
    picture: 'படம்',
    point: 'புள்ளி',
    position: 'நிலை',
    question: 'கேள்வி',
    quiz: 'வினாடி வினாவின் பெயர்',
    search_course: ' படிப்பு மூலம் தேடுங்கள்',
    search_media: 'மீடியாவை தேடுங்கள்',
    search_name: 'பெயரால் தேடுங்கள்',
    search_title: 'தலைப்பு மூலம் தேடுங்கள்',
    search_training: 'பயிற்சியைத் தேடுங்கள்',
    settings: 'அமைப்புகள்',
    tags: 'குறிச்சொற்கள்',
    title: 'தலைப்பு',
    topics: 'தலைப்புகள்',
    username: 'பயனர்பெயர்',
    keyword: 'முக்கிய வார்த்தைகள்',
    max_500_characters: 'அதிகபட்சம் 500 எழுத்துக்கள் ',
    no_description: 'இந்த கோப்பில் ஒரு விளக்கம் இல்லை',
    no_keyword: 'இந்த கோப்பில் எந்தவொரு முக்கிய வார்த்தைகளும் இல்லை',
    no_topics: 'இந்த கோப்பில் ஒரு தலைப்பு தொகுப்பு இல்லை',
    feedback: 'செய்தி',
    contact: 'நாங்கள் எவ்வாறு உதவ முடியும்?'
  },

  publishsettings: {
    title: 'அமைப்புகளை வெளியிடுக',
    event_subtitle:
      'உங்கள் நிகழ்வைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் நிகழ்வில் அமைப்புகளைச் சேர்க்கவும்',
    assessment_subtitile:
      'உங்கள் மதிப்பீட்டிற்கு பெயரிடுங்கள் மற்றும் அதிலிருந்து அவர்கள் என்ன கற்றுக்கொள்ள  எதிர்பார்க்க வேண்டும் என்பதை உங்கள் பார்வையாளர்களிடம் சொல்லுங்கள்',
    course_subtitle:
      'உங்கள் படிப்பைக் காணக்கூடிய மற்றும் தொடர்பு கொள்ளக்கூடிய வகையில் உங்கள் படிப்பில் அமைப்புகளைச் சேர்க்கவும்',
    disclaimer: `1.	பதிவு செய்தல்

ஒரு பயனராக பதிவு செய்வதன் மூலமும்/ ஒரு கணக்கை உருவாக்குவதன் மூலமும் நீங்கள் எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்



2.	பாடத்திட்ட உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் பாடத்திட்ட உள்ளடக்கத்தை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்



3.	நிகழ்வு உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் ஒரு நிகழ்வை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்


4.	மதிப்பீடு உருவாக்கம்

எங்கள் கருவிகளைப் பயன்படுத்துவதன் மூலமும் மற்றும் ஒரு மதிப்பீட்டை உருவாக்குவதன் மூலமும், எங்கள் [பயனர் ஒப்பந்தத்தை] மற்றும் எங்கள் [தனியுரிமைக் கொள்கையை] படித்து ஒப்புக்கொள்கிறீர்கள்`,
    dates_validation_error: 'இரண்டு தேதிகளும் நிரப்பப்பட வேண்டும்.',
    emails_validation_error: 'மின்னஞ்சல் பட்டியல் தவறானது.',
    specific_email_validation_error:
      'ஒரே ஒரு மின்னஞ்சல் மட்டுமே அனுமதிக்கப்படுகிறது.',
    i_agree_to_these: 'நான் ஒப்புக்கொள்கிறேன் இந்த ',
    terms_and_conditions: 'விதிமுறைகளையும் நிபந்தனைகளையும்.',
    PublicDescription:
      'இலவச சுயாதீன பயனர்கள்: (தனிப்பட்ட மற்றும் பொது விருப்பத்தேர்வுகள்) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட, கீழே உள்ள make it public  என்பதை நீங்கள் தேர்ந்தெடுக்கலாம். இதன் பொருள் இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் இந்த பாடத்திட்டம் கிடைக்கும் என்பதாகும்.',
    OrganisationsDescription:
      'நிறுவன பயனர்கள்: (""Finish"" என்பதற்கு பதிலாக ""Publish"" ஐப் பயன்படுத்தி பிற பயனர்களைப் போலவே அவர்களை வெளியீட்டு பக்கத்திற்கு கொண்டு வாருங்கள், ஆனால் வெளியீட்டு விருப்பத்தேர்வுகள் எதுவும் இல்லாமல்.) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் தனிப்பட்டது. இதன் பொருள் நீங்களும் உங்கள் நிறுவனத்தில் உள்ள நிர்வாகிகளும் மட்டுமே அதைப் பார்க்க முடியும். ஒரு பயனராக, நிர்வாகி உரிமைகள் தேவைப்படுவதால், உங்கள் உள்ளடக்கத்தை உங்கள் நிறுவனத்திற்குள் உங்களால் வெளியிட முடியாது. தயவுசெய்து உங்கள் நிர்வாகிகளில் ஒருவரைத் தொடர்புகொண்டு, உங்கள் உள்ளடக்கத்தை பொதுவில், முழு நிறுவனத்திற்கும், உங்கள் நிறுவனத்தில் உள்ள குறிப்பிட்ட குழுக்களுக்கு அல்லது குறிப்பிட்ட பயனர்களுக்கு வெளியிடச் சொல்லுங்கள்.',
    OrganisationGroupsDescription:
      'நிறுவன நிர்வாகிகள்: (நிறுவனத்திற்குள் உருவாக்கப்பட்ட உள்ளடக்கத்திற்கு: தனிப்பட்ட, பொது, அமைப்பு, குழுக்கள், குறிப்பிட்ட பயனர்கள்): இந்த [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டு இயல்புநிலையாக தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் (மற்றும் உள்ளடக்கம் உருவாக்கியவர்) மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது உங்கள் நிறுவனத்திற்கு வெளியே உள்ளவர்கள் உட்பட இயங்குதளத்தில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். அதை நிறுவனத்திற்குள் வெளியிடுவது என்பது நிறுவனத்தில் உள்ள அனைத்து பயனர்களும் அதைப் பார்க்க முடியும் என்பதாகும். நீங்கள் இதை 1 அல்லது அதற்கு மேற்பட்ட குழுக்களிலும் வெளியிடலாம், அதாவது அந்தக் குழுக்களில் உள்ள பயனர்கள் மட்டுமே அதைப் பார்க்க முடியும். கடைசியாக, உங்கள் நிறுவனத்திற்கு உள்ளேயும் வெளியேயும் குறிப்பிட்ட பயனர்களுக்கு அவர்களின் ஷேர்லுக் கணக்கு மின்னஞ்சல் முகவரியைப் பயன்படுத்தி வெளியிட உங்களுக்கு விருப்பத்தேர்வு உள்ளது.',
    SpecificUsersDescription:
      'கட்டண சுயாதீன பயனர்கள்: (தனிப்பட்ட, பொது மற்றும் குறிப்பிட்ட பயனர்கள்) உங்கள் [படிப்பு | நிகழ்வு | மதிப்பீடு] சேமிக்கப்பட்டது மற்றும் இயல்பாகவே தனிப்பட்டதாக கருதப்படுகிறது. இதன் பொருள் நீங்கள் மட்டுமே இந்த உள்ளடக்கத்தைக் காண முடியும். இந்த உள்ளடக்கத்தை வெளியிட நீங்கள் கீழே உள்ள விருப்பத்தேர்வுகளில் ஒன்றைத் தேர்ந்தெடுக்கலாம். உங்கள் பாடத்திட்டத்தை பொதுவில் வெளியிடுவது என்பது மேடையில் உள்ள அனைத்து பயனர்களுக்கும் கிடைக்கும் என்பதாகும். குறிப்பிட்ட பயனர்களின் விருப்பத்தேர்வு என்பது குறிப்பிட்ட பயனர்களின் ஷேர்லுக் கணக்குடன் தொடர்புடைய மின்னஞ்சல் முகவரியைப் பயன்படுத்தி உங்கள் பாடத்திட்டத்தைப் பகிர்ந்து கொள்ள உதவும் ஒரு விருப்பத்தேர்வு ஆகும்.'
  },

  quiz: {
    quiz_empty: 'நீங்கள் இன்னும் ஒரு வினாடி வினாவை உருவாக்கவில்லை',
    questions_empty: 'நீங்கள் இன்னும் ஒரு கேள்வியை உருவாக்கவில்லை'
  },

  regions: {
    asia_pacific_australia: 'ஆஸ்திரேலியா',
    asia_pacific_india: 'இந்தியா',
    asia_pacific_japan: 'ஜப்பான்',
    asia_pacific_s_korea: 'தென் கொரியா',
    asia_pacific_singapore: 'சிங்கப்பூர்',
    asia_pacific_taiwan: 'தைவான்',
    eu_belgium: 'பெல்ஜியம்',
    eu_germany: 'ஜெர்மனி',
    eu_ireland: 'அயர்லாந்து',
    south_america_brazil: 'பிரேசில்',
    us_central_iowa: 'அயோவா',
    us_east_s_carolina: 'தென் கரோலினா',
    us_east_virginia: 'வர்ஜீனியா',
    us_west_california: 'கலிபோர்னியா',
    us_west_oregon: 'ஒரேகான்'
  },

  reports: {
    title: 'அறிக்கைகள்',
    workshop_report: 'ஒர்க் ஷாப் அறிக்கை',
    user_report: 'பயனர் அறிக்கை',
    organization_workshop: 'நிறுவன ஒர்க் ஷாப்',
    course: 'படிப்பு',
    live_event: 'நேரலை நிகழ்வு',
    workShop_graph: 'ஒர்க் ஷாப் வரைபடம்',
    organization_account: 'நிறுவனக் கணக்கு',
    all: 'அனைத்தும்',
    name: 'பெயர்',
    id_number: 'ஐடி எண்',
    email: 'மின்னஞ்சல்',
    search_user_report: 'பயனர் அறிக்கையைத் தேடுங்கள்',
    participant: ' பங்கேற்பாளர்',
    participants: 'பங்கேற்பாளர்கள்',
    host: 'ஹோஸ்ட்',
    username: 'பயனர்பெயர்',
    event: 'நிகழ்வு',
    quiz: 'வினாடி வினா',
    assessment: 'மதிப்பீடு',
    time: 'நேரம்',
    no_recent_activity: 'சமீபத்திய செயல்பாடு எதுவும் இல்லை',
    workshops: 'ஒர்க் ஷாப்ஸ்',
    courses: 'படிப்புகள்',
    live_events: 'நேரலை நிகழ்வுகள்',
    live_assessments: 'நேரலை மதிப்பீடுகள்',
    quizzes: 'வினாடி வினாக்கள்',
    overview: 'கண்ணோட்டம்',
    by: 'மூலம்',
    views: 'பார்த்தது',
    status: 'நிலை',
    poll: 'கருத்து கணிப்பு',
    comment: 'கருத்து',
    comments: 'கருத்துகள்',
    no_comments: 'கருத்துகள் இல்லை',
    no_polls: 'கருத்துக் கணிப்புகள் இல்லை',
    live_date: 'நேரலை தேதி',
    score: 'மதிப்பெண்',
    question: 'கேள்வி',
    submit: 'சமர்ப்பிக்கவும்',
    recent_activity: 'சமீபத்திய செயல்பாடு',
    ago: 'முன்பு',
    no_data_found: 'தகவல்கள் காணப்படவில்லை',
    start_end_live: 'தொடங்கும் / முடியும் நேரலை',
    join_leave_date: 'சேருங்கள் / விட்டுச்செல்லுங்கள்',
    watched_time: 'பார்த்த நேரம்',
    complete: 'முழுமை',
    in_complete: 'முழுமையற்றது',
    today: 'இன்று',
    seven_days: '7 நாட்கள்',
    last_month: 'கடந்த மாதம்',
    one_year: '1 வருடம்',
    all_time: 'அனைத்து நேர',
    report: 'அறிக்கை',
    from_date: 'தேதியிலிருந்து',
    to_date: 'தேதி வரை',
    all_workshop: 'அனைத்து ஒர்க் ஷாப்',
    all_participants: 'அனைத்து பங்கேற்பாளர்கள்',
    live_assessment: 'நேரலை மதிப்பீடு',
    users: 'பயனர்கள்',
    download: 'பதிவிறக்கு',
    recent: 'சமீபத்திய',
    WorkShop: 'ஒர்க் ஷாப்',
    Activity: 'செயல்பாடு',
    created_date: 'உருவாக்கிய தேதி',
    lessons: 'பாடங்கள்',
    lesson: 'பாடம்',
    completed: 'நிறைவடைந்தது',
    report_download: 'அறிக்கை பதிவிறக்கம்',
    this_month: 'இந்த மாதம்',
    search_course: 'படிப்பைத் தேடுங்கள்',
    participants_graph: 'பங்கேற்பாளர்கள் வரைபடம்',
    viewed: 'பார்த்தது',
    enrolled: 'பதிவுசெய்தது',
    description: 'விளக்கம்',
    topic: 'தலைப்பு',
    analytic: 'பகுப்பாய்வு',
    quiz_list: 'வினாடி வினா பட்டியல்',
    select_one: 'ஒன்றை தேர்ந்தெடு',
    group_status: 'குழுவின் நிலை',
    duration_min: 'கால அளவு(நிமிடம்)',
    submit_poll: 'கருத்துக் கணிப்பை சமர்ப்பிக்கவும்',
    download_events: 'நிகழ்வுகளைப் பதிவிறக்குக',
    search_event: 'நிகழ்வை தேடு',
    duration: 'கால அளவு',
    total_participants: 'மொத்த பங்கேற்பாளர்கள்',
    message: 'செய்தி',
    avg_message: 'சராசரி. செய்தி',
    per_message: 'செய்திகள் / நிகழ்வின் ஒரு சதவீதம்'
  },

  signup: {
    success_step1:
      'நீங்கள் வழங்கிய முகவரிக்கு ஒரு சரிபார்ப்புக் குறியீட்டை நாங்கள் மின்னஞ்சல் செய்துள்ளோம், உங்கள் பதிவை உறுதிப்படுத்த கீழேயுள்ள புலத்தில் தயவுசெய்து குறியீட்டை நகலெடுக்கவும்.',
    success_step2: 'நன்றி. நீங்கள் வெற்றிகரமாக பதிவுசெய்துள்ளீர்கள்.',
    privacy: `ஷேர்லூக்கின் <1> விதிமுறைகள் மற்றும் நிபந்தனைகள்</1> மற்றும் <3> தனியுரிமைக் கொள்கை</3> ஆகியவற்றை நான் ஒப்புக்கொள்கிறேன்`
  },

  stream: {
    emotion_impressive: 'ஈர்க்கக்கூடிய',
    emotion_unimpressive: 'ஈர்க்காத',
    message_not_started: 'விரைவில்',
    message_running: 'நேரலை',
    message_processing:
      'பிளேபேக்கிற்கான நேரலை பதிவை நாங்கள் தற்போது செயலாக்குகிறோம். வீடியோவைக் காண, மேலும் மதிப்பீடுகள் மற்றும் கருத்துக்களைச் சேர்ப்பதைத் தொடர தயவுசெய்து பின்னர் சரிபார்க்கவும்'
  },

  tabs: {
    audience: 'பார்வையாளர்கள்',
    course: ' படிப்பின் கண்ணோட்டம்',
    details: 'நேரலை நிகழ்வு விவரங்கள்',
    description: 'விளக்கம்',
    host: 'ஹோஸ்ட்',
    lesson: 'பாடத்தின் கண்ணோட்டம்',
    lessons: 'பாடங்கள்',
    overview: 'கண்ணோட்டம்',
    page: 'பக்கம் கட்டுபவர்',
    publish: 'வெளியிடு',
    settings: 'அமைப்பை வெளியிடுக',
    total_views: 'மொத்தமாகப் பார்த்தது',
    live_participates: 'நேரலை பங்கேற்பாளர்கள்',
    live_chats: 'நேரலை சாட்ஸ்',
    live_quiz: 'நேரலை கருத்துக் கணிப்புகள்',
    trainer_rating: 'பயிற்சி மதிப்பீடு',
    trainer_times: 'பயிற்சியாளர் நேரம்',
    courses_quizzes: ' படிப்புகளின் வினாடி வினாக்கள்',
    user_list: 'பயனர் பட்டியல்',
    discussion: 'கலந்துரையாடல்',
    notes: 'எனது குறிப்புகள்'
  },

  topics: {
    SALES_TRAINING: 'விற்பனை பயிற்சி',
    NEGOTIATION_TRAINING: 'பேச்சுவார்த்தை பயிற்சி',
    CROSS_CULTURAL_AWARENESS: 'பல்லினக் கலாச்சார விழிப்புணர்வு',
    NETWORKING_SKILLS: 'நெட்வொர்க்கிங் திறன்கள்',
    SOFTWARE_ARCHITECTURE: 'மென்பொருள் கட்டமைப்பு',
    PROJECT_MANAGEMENT: 'திட்ட மேலாண்மை',
    DIGITAL_TRANSFORMATION: 'டிஜிட்டல் மாற்றம்',
    IT_CONSULTING: 'ஐடி ஆலோசனை',
    MANAGEMENT_CONSULTING: 'மேலாண்மை ஆலோசனை',
    HR_CONSULTING: 'மனிதவள ஆலோசனை',
    INTERNET_OF_THINGS: 'விஷயங்களின் தொழில்நுட்ப இணையம் (IoT)',
    CYBERSECURITY: 'சைபர் பாதுகாப்பு',
    PRIVACY_AND_GDRP: 'தனியுரிமை மற்றும் GDPR'
  },

  training: {
    title: 'பயிற்சி',
    title_assessment: 'மதிப்பீடுகள்',
    subtitle: 'பாடத்திட்டங்கள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_title: 'பதிவுசெய்யப்பட்ட பாடத்திட்டங்கள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_subtitle: 'நீங்கள் சேர்ந்த படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    enrolled_message:
      'நீங்கள் தற்போது எந்தவொரு படிப்புகளிலும் நிகழ்வுகளிலும் சேரவில்லை.',
    past_live_event_title: 'கடந்த நேரலை நிகழ்வுகள்',
    past_live_event_subTitle: 'முடிந்த நேரலை நிகழ்வுகள்',
    past_live_event: 'கடந்தகால நேரலை நிகழ்வுகள் எதுவும் தற்போது இல்லை.',
    recomended_title: 'பரிந்துரைக்கப்படும் படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    now_live_event_title: 'இப்போது நேரலை',
    now_live_event_subTitle:
      'நேரலையில் இருக்கும் நிகழ்வுகள் அல்லது மிக விரைவில் இருக்கும்',
    now_live_event: 'தற்போது நேரலை நிகழ்வு எதுவும் இல்லை.',
    webinar_event_title: 'வெபினார் சேனல்',
    webinar_event_subTitle: 'முடிந்த வெபினார்கள்',
    webinar_event: 'தற்போது வெபினார் எதுவும் இல்லை.',
    p2p_event_title: 'பயிற்சி அமர்வுகள்',
    p2p_event_subTitle: 'முடிந்த பயிற்சி அமர்வு',
    p2p_event: 'தற்போது பயிற்சி அமர்வு எதுவும் இல்லை.',

    now_live_assessment_title: 'இப்போது நேரலை',
    now_live_assessment_subTitle:
      'நேரலையில் இருக்கும் மதிப்பீடு அல்லது மிக விரைவில் இருக்கும்',
    now_live_assessment_message: 'தற்போது நேரலை மதிப்பீடு எதுவும் இல்லை.',

    upcoming_assessment_title: 'வரவிருக்கும் நேரலை மதிப்பீடுகள்',
    upcoming_assessment_subtitle: 'வரவிருக்கும் நேரலை மதிப்பீடுகள்',
    upcoming_assessment_message:
      'தற்போது வரவிருக்கும் நேரலை மதிப்பீடு எதுவும் இல்லை.',

    past_live_assessment_title: 'கடந்தகால நேரலை மதிப்பீடுகள்',
    past_live_assessment_subTitle: 'முடிந்த நேரலை மதிப்பீடுகள்',
    past_live_assessment_message:
      'கடந்தகால நேரலை மதிப்பீடுகள் தற்போது எதுவும் இல்லை.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'உங்கள் <0><0/></0> இன் அடிப்படையில் படிப்புகள் மற்றும் நேரலை நிகழ்வுகளை நாங்கள் உருவாக்கியுள்ளோம்',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'பயிற்சியைத் தேடுங்கள்',
    search_assessment: 'மதிப்பீட்டைத் தேடுங்கள்',
    recomended_message:
      'தற்போது பரிந்துரைக்கப்படும் படிப்புகள் மற்றும் நிகழ்வுகள் எதுவும் இல்லை.'
  },

  warnings: {
    delete: 'நீங்கள் உறுதியாக இருக்கிறீர்களா?'
  },

  workshop: {
    title: 'எனது ஒர்க் ஷாப்',
    subtitle:
      'ஒரு படிப்பதை உருவாக்குங்கள் அல்லது உங்கள் சொந்த ஒரு நேரலை நிகழ்வை ஹோஸ்ட் செய்யுங்கள்',
    new_course: 'ஒரு புதிய படிப்பை உருவாக்குங்கள்',
    new_event: 'ஒரு புதிய நேரலை நிகழ்வை உருவாக்குங்கள்',
    new_assessment: 'ஒரு புதிய நேரலை மதிப்பீட்டை உருவாக்குங்கள்',
    courses_title: 'உருவாக்கிய படிப்புகள் மற்றும் நேரலை நிகழ்வுகள்',
    courses_subtitle:
      'நீங்கள் உருவாக்கிய படிப்பைத் திருத்தி வெளியிடுங்கள் மற்றும் நேரலை நிகழ்வுகளைத் திட்டமிடுங்கள்',
    tags_course: 'படிப்பு',
    tags_live: 'நேரலை நிகழ்வு',
    tags_assessment: 'நேரலை மதிப்பீடு'
  },

  help_center: {
    sidebar: {
      title: 'உங்களுக்கு நாங்கள் எவ்வாறு உதவலாம்?',
      back_to: 'டாஷ்போர்டு'
    },
    menu: {
      help_center: 'உதவி மையம்',
      whats_new: 'புதியது என்ன',
      feedback: 'உங்கள் கருத்து',
      feedback_title: 'ஷேர்லூக்கிற்கு உங்கள் கருத்தை அனுப்பவும்',
      terms_and_conditions: 'விதிமுறைகள் & நிபந்தனைகள்',
      privacy_policy: 'தனியுரிமைக் கொள்கை',
      contact_us: 'எங்களை தொடர்பு கொள்ளுங்கள்'
    },
    get_started: {
      title: 'ஷேர்லூக் உடன் தொடங்கவும்',
      description: {
        main:
          'நாங்கள் நேரலை வீடியோவை ஒரு எளிதில் பயன்படுத்தக்கூடிய படிப்பு கட்டமைப்பாளருக்கு ஒருங்கிணைத்துள்ளோம்',
        tagline:
          'ஷேர்லூக்கின் காப்புரிமை பெற்ற நேரலை ஒளிபரப்பு அமைப்பு மூலம், நீங்கள் ஈடுபாட்டை உருவாக்கலாம், கற்றலை தானியங்குபடுத்தலாம் மற்றும் அறிவு பகிர்வை அதிகரிக்கலாம்.'
      }
    },
    whats_new: {
      title: 'ஷேர்லூக் உடன் தொடங்கவும்',
      description: {
        main:
          'கதை சொல்லும் பாணி கற்றலை குறுகிய காலத்தில் மற்றும் குறைந்த விலையில் உருவாக்க முடியும் என்பது உங்களுக்குத் தெரியுமா? ஷேர்லூக் படிப்பை கட்டுபவர் மற்றும் அந்தந்த திறமைகளை நீங்கள் இணைக்க வேண்டும். நீங்கள் எங்களிடம் "எப்படி" என்று கேட்கலாம்',
        tagline: ''
      }
    },
    create_workshop: 'ஒரு ஒர்க் ஷாப் உருவாக்குவது எப்படி',
    create_course: 'ஒரு படிப்பை உருவாக்குவது எப்படி',
    create_user: 'ஒரு பயனரை உருவாக்குவது எப்படி',
    create_group: 'ஒரு குழுவை உருவாக்குவது எப்படி',
    create_webinar: 'வெபினார் உருவாக்குவது எப்படி',
    create_live_event: 'நேரலை நிகழ்வை உருவாக்குவது எப்படி',
    create_live_assessment: 'நேரலை மதிப்பீட்டை உருவாக்குவது எப்படி',
    create_live_on_mobile: 'மொபைலில் நேரலை உருவாக்கவும்',
    personalize_profile: 'ஒரு சுயவிவரத்தைத் தனிப்பயனாக்குங்கள்',
    manage_group: 'குழுவை நிர்வகிக்கவும்',
    report: 'அறிக்கை',
    add_annotations: 'சிறுகுறிப்புகள்/பாப்அப்களை எவ்வாறு சேர்ப்பது',
    add_audio: 'ஆடியோவை எவ்வாறு சேர்ப்பது',
    add_header_and_footer: 'தலைப்பு மற்றும் அடிக்குறிப்பைச் சேர்த்தல்',
    add_image: 'படத்தை எவ்வாறு சேர்ப்பது',
    add_quiz_content: 'வினாடி வினா உள்ளடக்கத்தை எவ்வாறு சேர்ப்பது',
    add_text_content: 'உரை உள்ளடக்கத்தை எவ்வாறு சேர்ப்பது',
    add_user: 'பயனரை எவ்வாறு சேர்ப்பது',
    add_video: 'வீடியோவை எவ்வாறு சேர்ப்பது',
    clone_course: 'படிப்புகளை குளோன் செய்வது எப்படி',
    find_live_broadcast: 'நேரலை ஒளிபரப்பை எவ்வாறு கண்டுபிடிப்பது',
    contact_us: {
      title: 'எங்களை தொடர்பு கொள்ளுங்கள்',
      subject_placeholder: 'ஒரு தலைப்பை உள்ளிடவும்*',
      content_placeholder: 'ஒரு செய்தியை உள்ளிடவும்*',
      subject_required: '*தலைப்பு தேவை',
      content_required: '*செய்தி தேவை',
      submit: 'அனுப்புக',
      cancel: 'ரத்துசெய்',
      sent: 'அனுப்பப்பட்டது'
    },
    feedback: {
      title: 'ஷேர்லூக்கிற்கு உங்கள் கருத்தை அனுப்பவும்',
      attach_title: 'ஒரு கோப்பை இணைக்கவும்',
      choose: 'கோப்பை தேர்வுச்செய்யுங்கள்',
      detail: 'கோப்பு ஆதரவு குழுவுடன் பகிரப்படும்',
      content_placeholder: 'ஒரு செய்தியை உள்ளிடவும்*',
      content_required: '*செய்தி தேவை',
      submit: 'அனுப்புக',
      cancel: 'ரத்துசெய்',
      sent: 'அனுப்பப்பட்டது'
    }
  },
  discussion: {
    join_discussion: 'கலந்துரையாடலில் சேரவும்'
  },
  notes: {
    title: 'எனது குறிப்புகள்',
    add_note: 'புதிய குறிப்பைச் சேர்க்கவும்'
  }
}
